export const keys = <T extends Record<string, any>>(val: T): (keyof T)[] =>
    Object.keys(val) as (keyof T)[];
